import { FormEvent } from "react";
import Modal from "../../../common/Modal";
import { useAdmin } from "../../../../context/admin";
import AdminService from "../../../../services/admin.service";
import { AiFillCloseCircle } from "react-icons/ai";
import { useGlobal } from "../../../../context/global";

export default function ConfirmDeleteCar() {
    const { setIsLoading } = useGlobal()
    const { confirmDeleteCarId, setConfirmDeleteCarId } = useAdmin()
    async function onSubmit(e: FormEvent<HTMLFormElement>) {
        e.preventDefault()
        setIsLoading(true)
        try {
            await AdminService.deleteCar(confirmDeleteCarId!)
            window.location.reload()
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false)
        }
    }
    return (
        <Modal onSubmit={onSubmit}>
            <h1>Are you sure you want to delete this car?</h1>
            <p>This action cannot be undone.</p>
            {/* Buttons for confirming or cancelling the deletion would go here */}
            <div className="actions" style={{display: 'flex', gap: '10px', marginTop: '20px'}}>
                <button style={{backgroundColor: 'red', color: 'white', border: 'none'}}
                >Delete</button>
                <button type="button" style={{backgroundColor: 'gray', color: 'white', border: 'none'}}
                onClick={() => setConfirmDeleteCarId(undefined)}
                >Cancel</button>
            </div>
            <div className="close" onClick={() => setConfirmDeleteCarId(undefined)}>
                <AiFillCloseCircle />
            </div>
        </Modal>
    )
}